import { AssetProxyId, ObjectMap } from '@0x/types';

import { AssetMetaData } from '../types';

export const assetMetaDataMap: ObjectMap<AssetMetaData> = {
    '0xf47261b0000000000000000000000000e41d2489571d322189246dafa5ebde1f4699f498': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#333333',
        symbol: 'zrx',
        name: '0x',
    },
    '0xf47261b000000000000000000000000042d6622dece394b54999fbd73d108123806f6a18': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#EC4F81',
        symbol: 'spank',
        name: 'Spank',
    },
    '0xf47261b0000000000000000000000000d26114cd6ee289accf82350c8d8487fedb8a0c07': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#2458E7',
        symbol: 'omg',
        name: 'OmiseGo',
    },
    '0xf47261b00000000000000000000000009f8f72aa9304c8b593d555f12ef6589cc3a579a2': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#68CCBB',
        symbol: 'mkr',
        name: 'Maker',
    },
    '0xf47261b00000000000000000000000000d8775f648430679a709e98d2b0cb6250d2887ef': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#FF5000',
        symbol: 'bat',
        name: 'Basic Attention Token',
    },
    '0xf47261b0000000000000000000000000744d70fdbe2ba4cf95131626614a1763df805b9e': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#4763D7',
        symbol: 'snt',
        name: 'Status',
    },
    '0xf47261b00000000000000000000000000f5d2fb29fb7d3cfee444a200298f468908cc942': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#f08839',
        symbol: 'mana',
        name: 'Decentraland',
    },
    '0xf47261b00000000000000000000000001985365e9f78359a9b6ad760e32412f4a445e862': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#512D80',
        symbol: 'rep',
        name: 'Augur',
    },
    '0xf47261b00000000000000000000000000abdace70d3790235af448c88547603b945604ea': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#2c3c8c',
        symbol: 'dnt',
        name: 'district0x',
    },
    '0xf47261b000000000000000000000000005f4a42e251f2d52b8ed15e9fedaacfcef1fad27': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 12,
        primaryColor: '#048998',
        symbol: 'zil',
        name: 'Zilliqa',
    },
    '0xf47261b00000000000000000000000008f8221afbb33998d8584a2b05749ba73c37a938a': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#58BFD6',
        symbol: 'req',
        name: 'Request Network',
    },
    '0xf47261b0000000000000000000000000e0b7927c4af23765cb51314a0e0521a9645f0e2a': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 9,
        primaryColor: '#E1AA3E',
        symbol: 'dgd',
        name: 'DigixDao',
    },
    '0xf47261b00000000000000000000000004f3afec4e5a3f2a6a1a411def7d7dfe50ee057bf': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 9,
        primaryColor: '#E1AA3E',
        symbol: 'dgx',
        name: 'Digix Gold Token',
    },
    '0xf47261b0000000000000000000000000419d0d8bdd9af5e606ae2232ed285aff190e711b': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 8,
        primaryColor: '#E40057',
        symbol: 'fun',
        name: 'FunFair',
    },
    '0xf47261b000000000000000000000000041e5560054824ea6b0732e656e3ad64e20e94e45': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 8,
        primaryColor: '#04bc24',
        symbol: 'cvc',
        name: 'Civic',
    },
    '0xf47261b00000000000000000000000005ca9a71b1d01849c0a95490cc00559717fcf0d1d': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#F7296E',
        symbol: 'ae',
        name: 'Aeternity',
    },
    '0xf47261b0000000000000000000000000408e41876cccdc0f92210600ef50372656052a38': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#233C5A',
        symbol: 'ren',
        name: 'Republic Protocol',
    },
    '0xf47261b0000000000000000000000000514910771af9ca656af840dff83e8264ecf986ca': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#325CD2',
        symbol: 'link',
        name: 'ChainLink',
    },
    '0xf47261b00000000000000000000000006810e776880c02933d47db1b9fc05908e5386b96': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#48A4C0',
        symbol: 'gno',
        name: 'Gnosis',
    },
    '0xf47261b0000000000000000000000000960b236a07cf122663c4303350609a66a7b288c0': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#04a29e',
        symbol: 'ant',
        name: 'Aragon',
    },
    '0xf47261b00000000000000000000000004156d3342d5c385a87d264f90653733592000581': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 8,
        primaryColor: '#4CABA7',
        symbol: 'salt',
        name: 'Salt',
    },
    '0xf47261b0000000000000000000000000595832f8fc6bf59c85c527fec3740a1b7a361269': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 6,
        primaryColor: '#5BC9D4',
        symbol: 'powr',
        name: 'PowerLedger',
    },
    '0xf47261b00000000000000000000000008eb24319393716668d768dcec29356ae9cffe285': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 8,
        primaryColor: '#523CE8',
        symbol: 'agi',
        name: 'SingularityNET',
    },
    '0xf47261b000000000000000000000000039bb259f66e1c59d5abef88375979b4d20d98022': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 8,
        primaryColor: '#EDB740',
        symbol: 'wax',
        name: 'WAX',
    },
    '0xf47261b0000000000000000000000000beb9ef514a379b997e0798fdcc901ee474b6d9a1': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#333333',
        symbol: 'mln',
        name: 'Melon',
    },
    '0xf47261b000000000000000000000000058b6a8a3302369daec383334672404ee733ab239': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#232D37',
        symbol: 'lpt',
        name: 'Livepeer',
    },
    '0xf47261b000000000000000000000000027054b13b1b798b345b591a4d22e6562d47ea75a': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 4,
        primaryColor: '#3A74F6',
        symbol: 'ast',
        name: 'AirSwap',
    },
    '0xf47261b000000000000000000000000089d24a6b4ccb1b6faa2625fe562bdd9a23260359': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#DEA349',
        symbol: 'sai',
        name: 'Dai Stablecoin (SAI)',
    },
    '0xf47261b00000000000000000000000006b175474e89094c44da98b954eedeac495271d0f': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#DEA349',
        symbol: 'dai',
        name: 'Dai Stablecoin (DAI)',
    },
    '0xf47261b0000000000000000000000000a0b86991c6218b36c1d19d4a2e9eb0ce3606eb48': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 6,
        primaryColor: '#2775CA',
        symbol: 'usdc',
        name: 'USD Coin',
    },
    '0xf47261b00000000000000000000000004946fcea7c692606e8908002e55a582af44ac121': {
        assetProxyId: AssetProxyId.ERC20,
        decimals: 18,
        primaryColor: '#a9786e',
        symbol: 'foam',
        name: 'FOAM',
    },
};
